import React, { useMemo } from 'react';
import styles from './UIGamePlayerInfoSectionContent.module.scss';
import { CardEnum, CardTypeEnum } from '@colonist/game-states';
import { UIGameCityImprovementTracker } from '../../../../../common/UIGameCityImprovementTracker/UIGameCityImprovementTracker.tsx';
import { UIGameCardInventory } from '../../../../../common/UIGameCardInventory/UIGameCardInventory.tsx';
import { CardDataController } from '@colonist/game-card-types';
import { Tooltip, T } from '@colonist/ui';
import { CARD_STACK_SIZES_1 } from '../CardStateUnorderedStackSize1.ts';
const PROGRESS_CARD_BACKS = [
    {
        backEnum: CardEnum.ProgressCardScienceBack,
        type: CardTypeEnum.ProgressScience
    },
    {
        backEnum: CardEnum.ProgressCardTradeBack,
        type: CardTypeEnum.ProgressTrade
    },
    {
        backEnum: CardEnum.ProgressCardPoliticsBack,
        type: CardTypeEnum.ProgressPolitics
    }
];
export const UIGamePlayerInfoSectionContentCK = ({ progressCardState, cityImprovementState })=>{
    const { cardState, cardsToDisable, cardsToHideBadge } = useMemo(()=>{
        const resultCardState = {};
        const resultCardsToDisable = {};
        const resultCardsToHideBadge = [];
        for (const { backEnum, type } of PROGRESS_CARD_BACKS){
            const cardEnums = CardDataController.getCardEnumsOfTypes([
                type
            ]);
            var _progressCardState_backEnum;
            let count = (_progressCardState_backEnum = progressCardState[backEnum]) !== null && _progressCardState_backEnum !== void 0 ? _progressCardState_backEnum : 0;
            for (const cardEnum of cardEnums){
                var _progressCardState_cardEnum;
                count += (_progressCardState_cardEnum = progressCardState[cardEnum]) !== null && _progressCardState_cardEnum !== void 0 ? _progressCardState_cardEnum : 0;
            }
            resultCardState[backEnum] = Math.max(count, 1);
            if (count === 0) {
                resultCardsToDisable[backEnum] = 1;
                resultCardsToHideBadge.push(backEnum);
            }
        }
        return {
            cardState: resultCardState,
            cardsToDisable: resultCardsToDisable,
            cardsToHideBadge: resultCardsToHideBadge
        };
    }, [
        progressCardState
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.cityImprovementTrackerContainer
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.cityImprovementButton.body.0"
        })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.cityImprovementButton.body.1"
        }))),
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.cityImprovementButton.title"
        })
    }, /*#__PURE__*/ React.createElement(UIGameCityImprovementTracker, {
        className: styles.cityImprovementTracker,
        cityImprovementState: cityImprovementState
    }))), /*#__PURE__*/ React.createElement(UIGameCardInventory, {
        className: styles.progressCardBacksContainer,
        cardState: cardState,
        cardStackSizes: CARD_STACK_SIZES_1,
        cardsToDisable: cardsToDisable,
        cardsToHideBadge: cardsToHideBadge,
        cardSize: "xxs",
        enablePartition: false,
        showTipTitle: true,
        forceShowCardBadges: true
    }));
};
